import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    FormControlLabel,
    Checkbox,
    Box
} from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import ThermostatIcon from '@mui/icons-material/Thermostat';

const FreteGratisExportModal = ({ open, onClose, onConfirm, loading = false }) => {
    const [weeklyComparison, setWeeklyComparison] = useState(false);

    const handleConfirm = () => {
        onConfirm({ weeklyComparison });
        handleClose();
    };

    const handleClose = () => {
        setWeeklyComparison(false);
        onClose();
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 3,
                    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)'
                }
            }}
        >
            <DialogTitle sx={{ 
                display: 'flex', 
                alignItems: 'center', 
                gap: 1.5,
                pb: 1,
                borderBottom: '1px solid #f0f0f0'
            }}>
                <DownloadIcon sx={{ color: '#ff9800' }} />
                <Typography variant="h6" sx={{ fontWeight: 600, color: '#333' }}>
                    Confirmar Exportação
                </Typography>
            </DialogTitle>

            <DialogContent sx={{ py: 3 }}>
                <Typography variant="body1" sx={{ mb: 3, mt: 3, color: '#555' }}>
                    Deseja exportar os dados de frete grátis?
                </Typography>

                <Box sx={{ 
                    bgcolor: '#fff8f0', 
                    border: '1px solid #ffe0b3',
                    borderRadius: 2, 
                    p: 2,
                    mb: 2
                }}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={weeklyComparison}
                                onChange={(e) => setWeeklyComparison(e.target.checked)}
                                sx={{ 
                                    color: '#ff9800', 
                                    '&.Mui-checked': { color: '#ff9800' }
                                }}
                            />
                        }
                        label={
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <ThermostatIcon sx={{ color: '#ff9800', fontSize: 20 }} />
                                <Box>
                                    <Typography variant="body2" sx={{ fontWeight: 600, color: '#333' }}>
                                        Modelo de calor
                                    </Typography>
                                    <Typography variant="caption" sx={{ color: '#666' }}>
                                        Incluir comparação semanal na exportação
                                    </Typography>
                                </Box>
                            </Box>
                        }
                        sx={{ m: 0 }}
                    />
                </Box>
            </DialogContent>

            <DialogActions sx={{ p: 3, pt: 1, gap: 1 }}>
                <Button
                    onClick={handleClose}
                    sx={{
                        color: '#6c757d',
                        fontWeight: 500,
                        px: 3
                    }}
                >
                    Cancelar
                </Button>
                <Button
                    variant="contained"
                    startIcon={<DownloadIcon />}
                    onClick={handleConfirm}
                    disabled={loading}
                    sx={{
                        bgcolor: "#ff9800",
                        color: "white",
                        fontWeight: 600,
                        px: 3,
                        boxShadow: '0 2px 8px rgba(255, 152, 0, 0.3)',
                        "&:hover": { 
                            bgcolor: "#f57c00",
                            boxShadow: '0 4px 12px rgba(255, 152, 0, 0.4)'
                        }
                    }}
                >
                    {loading ? 'Processando...' : 'Exportar'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default FreteGratisExportModal;